// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionTitle_root__31EqI","title":"SectionTitle_title__3LDYZ","description":"SectionTitle_description__jht3z"};